import React from 'react'
import logo from './logo.svg'
import Main from './features/main/Main'
import {Provider} from 'react-redux'
import store from './store'
import styled, {keyframes} from 'styled-components'
// import Loading from './components/Loading'

const Container = styled.div``

const Inner = styled.main`
  min-height: 100vh;
  //display: flex;
  //flex-direction: column;
  //align-items: center;
  //justify-content: center;
  font-size: calc(10px + 2vmin);
`

const float = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
  }
`

const Logo = styled.img`
  height: 20vmin;
  pointer-events: none;

  @media (prefers-reduced-motion: no-preference) {
    animation: ${float} 2s alternate infinite;
  }
`

const App = () => {
  return (
    <Provider store={store}>
      <Container>
        <Inner>
          {/*<Logo src={logo} alt="logo" />*/}
          <Main />
        </Inner>
      </Container>
    </Provider>
  )
}

export default App
